import accountDocumentService from "../services/account.document";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        errors: null,
        document: null,
        bankDetails: null
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        setDocument(state, value) {
            state.document = value;
        },
        setBankDetails(state, value) {
            state.bankDetails = value;
        }
    },
    actions: {
        uploadDocument: async ({ commit }, payload) => {
            commit("loading");

            return new Promise((resolve, reject) => {
                accountDocumentService
                    .uploadDocument(payload)
                    .then(response => {
                        commit("errors", null);
                        return resolve(response);
                    })
                    .catch(({ status, errors }) => {
                        commit("errors", errors);
                        return reject(status, errors);
                    })
                    .finally(() => commit("loading", false));
            });
        },
        saveBankDetails: async ({ commit }, payload) => {
            commit("loading");

            return new Promise((resolve, reject) => {
                accountDocumentService
                    .saveBankDetails(payload)
                    .then(response => {
                        commit("errors", null);
                        return resolve(response);
                    })
                    .catch(({ status, errors }) => {
                        commit("errors", errors);
                        return reject(status, errors);
                    })
                    .finally(() => commit("loading", false));
            });
        },
        getBankDetails: async ({ commit }, payload) => {
            commit("loading");

            try {
                const response = await accountDocumentService.getBankDetails(
                    payload
                );

                commit("setBankDetails", response.data);
            } catch ({ errors }) {
                notification.warning("Oops, cannot get bank details.");
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        }
    }
};
